import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMap, GeoJSON } from 'react-leaflet';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { makeStyles } from '@material-ui/core/styles';
import { find } from 'lodash'

import { computeColorLabels, findClosestLabel } from '../../../../utils/gradient';

const useStyles = makeStyles((theme) => ({
    alert: {
        '& .MuiAlert-root': {
            margin: 0
        },
        '& .MuiAlert-icon': {
            height: theme.spacing(0.5),
        },
        '& .MuiAlert-message': {
            fontSize: theme.spacing(2),
        },
    }
}));

function ZoneLayer({ data, legend, opacity }) {
    const classes = useStyles();
    const groupRef = useRef();
    const map = useMap();
    const { t } = useTranslation();
    const labels = React.useMemo(() => (legend ? computeColorLabels(legend) : null), [legend])

    const onEachFeature = (feature, layer) => {
        var tooltip = null
        var lb = null
        if (feature.properties?.index){
            tooltip = (`<b fontSize: 16px">${feature.id} - ${feature.properties?.index?.toFixed(2)}</b>`);
            
            lb = findClosestLabel(labels, feature.properties?.index)
        }

        if (feature.properties?.mean){
            tooltip = (`<b fontSize: 16px">${t("zone")} ${feature.id} <br/> Mean: ${feature.properties?.mean?.toFixed(2)}</b>`);
            console.log(labels, feature.properties?.mean, legend)
            lb = findClosestLabel(labels, feature.properties?.mean)
        }
            
        layer.bindTooltip(tooltip);

        if (lb) layer.setStyle({ color: lb.color, fillColor: lb.color, fillOpacity: opacity })
        else if (feature.properties?.color) {
            layer.setStyle({ color: feature.properties?.color, fillColor: feature.properties?.color, fillOpacity: opacity })
        }
    };

    React.useEffect(() => {
        map.fitBounds(groupRef.current.getBounds())
    }, [groupRef])

    React.useEffect(() => {
        if (groupRef.current) {
            groupRef.current.clearLayers()   // remove old data
            groupRef.current.addData(data) // might need to be geojson.features
        }
    }, [data])

    return (
        <GeoJSON data={data} color="red" name="Zones"
            onEachFeature={onEachFeature}
            ref={groupRef} />
    );
}

export default withWidth()(ZoneLayer);